export const azureDevOpsPickerValidation = (
  value: any,
  validation: any,
) => {
  if (!value || !value.projectName) {
    validation.addError('Debe seleccionar un proyecto de Azure DevOps');
  }

  if (value?.projectName && typeof value.projectName !== 'string') {
    validation.addError('El nombre del proyecto debe ser una cadena de texto');
  }

  if (value?.projectName && value.projectName.trim().length === 0) {
    validation.addError('El nombre del proyecto no puede estar vacío');
  }
};

export const azureDevOpsProjectPickerValidation = (
  value: any,
  validation: any,
) => {
  if (!value || typeof value !== 'string') {
    validation.addError('Debe seleccionar un proyecto de Azure DevOps');
  }

  if (value && typeof value === 'string' && value.trim().length === 0) {
    validation.addError('El nombre del proyecto no puede estar vacío');
  }
};

export const azureDevOpsRepositoryPickerValidation = (
  value: any,
  validation: any,
) => {
  if (!value || typeof value !== 'string') {
    validation.addError('Debe seleccionar un repositorio de Azure DevOps');
  }

  if (value && typeof value === 'string' && value.trim().length === 0) {
    validation.addError('El nombre del repositorio no puede estar vacío');
  }
};

export const azureDevOpsBranchPickerValidation = (
  value: any,
  validation: any,
) => {
  if (!value || typeof value !== 'string') {
    validation.addError('Debe seleccionar una rama de Azure DevOps');
  }

  if (value && typeof value === 'string' && value.trim().length === 0) {
    validation.addError('El nombre de la rama no puede estar vacío');
  }

  // Validación adicional para nombres de rama válidos
  if (value && typeof value === 'string' && value.trim().length > 0) {
    const invalidChars = /[<>:"\\|?*\x00-\x1f]/;
    if (invalidChars.test(value)) {
      validation.addError('El nombre de la rama contiene caracteres no válidos');
    }
  }
};
